const DownloadIcon = () => {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.125 20.625L24 28.5L31.875 20.625" stroke="#0F1110" strokeWidth="2" strokeLinecap="round"
                  strokeLinejoin="round"/>
            <path d="M24 7.49451V28.4945" stroke="#0F1110" strokeWidth="2" strokeLinecap="round"
                  strokeLinejoin="round"/>
            <path
                d="M42 25.5V39C42 39.3978 41.842 39.7794 41.5607 40.0607C41.2794 40.342 40.8978 40.5 40.5 40.5H7.5C7.10218 40.5 6.72064 40.342 6.43934 40.0607C6.15804 39.7794 6 39.3978 6 39V25.5"
                stroke="#0F1110" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
            />
        </svg>
    )
}

export default DownloadIcon